module.exports = __webpack_public_path__ + "src/assets/_textures/environmet/room_texture.jpg";